import { DEFAULT_EXPENSE_ITEMS } from "./constants";
import { mkMap, makeId } from "./utils";

export function makeInitial(months) {
  return {
    revenue:[
      {id:1, mode:"direct", name:"売上A", monthly:mkMap(months,2000000)},
      {id:2, mode:"direct", name:"売上B", monthly:mkMap(months,1000000)},
    ],
    staff:[
      {id:10, name:"スタッフ1", salary:mkMap(months,650000), bonus:mkMap(months,0), transport:mkMap(months,10000)},
      {id:11, name:"スタッフ2", salary:mkMap(months,650000), bonus:mkMap(months,0), transport:mkMap(months,10000)},
    ],
    expenses: Object.fromEntries(DEFAULT_EXPENSE_ITEMS.map(e=>[e.id, mkMap(months, e.id==="office"?50000:e.id==="insurance"?120000:0)])),
    actuals: {
      revItems:{},
      items: Object.fromEntries(DEFAULT_EXPENSE_ITEMS.map(e=>[e.id, mkMap(months,"")])),
      simple:{
        revItems:[{id:makeId("simpleRev"), name:"売上合計", monthly:mkMap(months,"")}],
        expItems:[{id:makeId("simpleExp"), name:"費用合計", monthly:mkMap(months,"")}],
        rev:mkMap(months,""),
        exp:mkMap(months,""),
      },
    },
    // CFシミュレーター用：売上行ごとの入金サイト設定
    cfSettings: {
      revSites: {},      // { [revId]: "same"|"next"|"next2" }
      expSite: "next",   // 経費全体のデフォルト支払いサイト
      taxMonths: {       // 税金支払い月（月名: 金額）
        消費税: mkMap(months, 0),
        法人税: mkMap(months, 0),
      },
      openingBalance: 0, // 期首現預金残高
    },
  };
}
